import Repository from './Repository';

const resource = "/tags";
export default {
    page(website_id, page=1, limit=10, search='') {
        var offset = (page - 1) * limit
        if(search) { search = `&search=${search}` }
        return Repository.get(`${resource}/?website=${website_id}&limit=${limit}&offset=${offset}${search}`);
    },
}